/**
 * React hooky pro PIP měnič — data fetching + selektory ze Zustand storu.
 */

import { useCallback, useEffect } from "react";
import { toast } from "sonner";
import { getPipList, getPipSnapshot } from "@client/api/pip";
import { usePipStore } from "@client/store/pip";

export const useFetchPipList = () => {
  const setDevices = usePipStore((s) => s.setDevices);
  return useCallback(async () => {
    try {
      const res = await getPipList();
      setDevices(res.responseObject ?? []);
    } catch (err) {
      toast.error("Nepodařilo se načíst seznam měničů");
      console.error(err);
    }
  }, [setDevices]);
};

export const useFetchPipSnapshot = (slug: string | undefined) => {
  const applyState = usePipStore((s) => s.applyState);
  return useCallback(async () => {
    if (!slug) return;
    try {
      const res = await getPipSnapshot(slug);
      const runtime = res.responseObject?.runtime;
      if (runtime) {
        applyState({
          slug,
          status: runtime.status,
          deviceInfo: runtime.deviceInfo ?? undefined,
          settings: runtime.settings ?? undefined,
        });
      }
    } catch (err) {
      console.error(err);
    }
  }, [slug, applyState]);
};

export const usePipList = () => {
  const devices = usePipStore((s) => s.devices);
  const loaded = usePipStore((s) => s.loaded);
  const fetch = useFetchPipList();
  useEffect(() => {
    if (!loaded) void fetch();
  }, [loaded, fetch]);
  return { devices, loaded, refresh: fetch };
};

export const usePipDevice = (slug: string | undefined) => {
  const device = usePipStore((s) => s.devices.find((d) => d.slug === slug));
  const telemetry = usePipStore((s) => (slug ? s.telemetry.get(slug) : undefined));
  const history = usePipStore((s) => (slug ? s.history.get(slug) : undefined));
  return { device, telemetry, history };
};
